import { StateService } from "@uirouter/angular";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IWorkflowActions, IWorkflowUi } from "@gtmhub/goals/models";
import { applyWorkflowConditions, generateWorkflowUi } from "@gtmhub/goals/workflowUtils";
import { getCurrentUserId } from "@gtmhub/users";
import { IItemWorkflow } from "@webapp/okrs/goals/models/goal-workflow.models";

@Component({
  selector: "okr-workflow",
  templateUrl: "okr-workflow.component.html",
  styleUrls: ["./okr-workflow.component.less"],
})
export class OkrWorkflowComponent implements OnChanges {
  @Input() public goalId: string;
  @Input() public workflow: IItemWorkflow;
  @Input() public actions: IWorkflowActions;

  public workflowUi: IWorkflowUi;

  constructor(private stateService: StateService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.actions && this.workflow && (changes.actions || changes.workflow)) {
      this.workflowUi = applyWorkflowConditions(generateWorkflowUi(this.actions, this.workflow, getCurrentUserId()));
    }
  }

  public editReviewers(): void {
    if (this.workflowUi.owner) {
      this.stateService.go("._approve.sendForApproval");
    }
  }

  public approveOkr(): void {
    window.setTimeoutOutsideAngular(() => {
      this.stateService.go("._review.review", { action: "approve" });
    });
  }

  public declineOkr(): void {
    window.setTimeoutOutsideAngular(() => {
      this.stateService.go("._review.review", { action: "decline" });
    });
  }

  public withdrawOkr(): void {
    window.setTimeoutOutsideAngular(() => {
      this.stateService.go("._review.review", { action: "withdraw" });
    });
  }

  public getReviewersIds(): string[] {
    return this.workflow?.reviewers?.reduce((acc: string[], reviewer) => {
      acc.push(reviewer.id);
      return acc;
    }, []);
  }
}
